import React, { useState, useEffect, useRef } from "react";
import { useForm } from '../../hooks/useForm';
import { useAxiosPost } from '../../hooks/useAxiosPost';
import './ideasForm.css'
import { useTranslation } from "react-i18next";

const IdeasForm = ({ isOpen, closeModal }) => {

    const dialogRef = useRef(null);

    const [count, setCount] = useState(0);
    const [correo, setCorreo] = useState('');
    const [nombre, setNombre] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isSent, setIsSent] = useState(false);
    const [t, i18n] = useTranslation("ideas_libertad");
    const [t2] = useTranslation("detail_blog");

    // CONTROL DIALOG
    useEffect(() => {

        if (isOpen) {
            dialogRef.current?.showModal();
        } else {
            dialogRef.current?.close();
        }

    }, [isOpen]);

    const onInputChangeCorreo = (event) => {

        const { value } = event.target;

        setCorreo(value);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        setIsValidEmail(emailRegex.test(value));
    };

    const onInputChangeNombre = (e) => {
        setNombre(e.target.value);
    };

    const [formSubmitted, setFormSubmitted] = useState(false);

    const {
        formState,
        onInputChange,
        subject,
        body,
        onResetForm
    } = useForm({
        subject: '',
        body: '',
        correo: correo
    });

    const notAllowedChars = [
        '"',
        '`',
        '=',
        ';',
        '[',
        ']',
        '{',
        '}',
        '(',
        ')',
        '/',
        '\\',
        '&',
        '<',
        '>'
    ];

    const handleInputChangeValidated = (event) => {

        onInputChange(event);

        const value = event.target.value;

        const containsNotAllowedChars =
            notAllowedChars.some(char => value.includes(char));

        let cleanBody = '';

        if (containsNotAllowedChars) {

            event.target.classList.add("invalid");

            for (let character of body) {
                cleanBody += notAllowedChars.includes(character)
                    ? ''
                    : character;
            }

            onInputChange({
                target: {
                    name: 'body',
                    value: cleanBody
                }
            });

        } else {

            event.target.classList.remove("invalid");
        }

        setCount(event.target.value.length);
    };

    const {
        data,
        isLoading,
        error
    } = useAxiosPost(
        formSubmitted
            ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/email/send-email-comment'
            : null,
        {
            fromName: ' ',
            from: ' ',
            to: ' ',
            subject: 'Nueva propuesta tema',
            body:
                nombre +
                '\n' +
                correo +
                '\n' +
                subject +
                '\n' +
                body,
            isBodyHtml: false
        }
    );

    const onFormSubmit = (event) => {

        event.preventDefault();

        if (nombre.length <= 1) {
            alert((t2('comments.v_nombre')));
            return;
        }

        if (correo.length <= 1) {
            alert((t2('comments.v_email')));
            return;
        }

        if (body.length <= 1) {
            alert((t2('comments.v_idea')));
            return;
        }

        if (!isValidEmail) {
            alert((t2('comments.v_valido')));
            return;
        }

        let cleanBody = '';

        for (let character of body) {
            cleanBody += notAllowedChars.includes(character)
                ? ' '
                : character;
        }

        onInputChange({
            target: {
                name: 'body',
                value: cleanBody
            }
        });

        setFormSubmitted(true);
    };

    const handleClose = () => {

        setIsSent(false);
        setFormSubmitted(false);
    
        setNombre('');
        setCorreo('');
        setCount(0);
    
        onResetForm();
    
        dialogRef.current?.close();
    
        closeModal();
    };

    useEffect(() => {

        if (formSubmitted && !isLoading && !error) {

            setIsSent(true);
            setFormSubmitted(false);

            onResetForm();
            setNombre('');
            setCorreo('');
            setCount(0);
        }

    }, [isLoading, error]);

    return (

        <dialog
            ref={dialogRef}
            className="write-me-modal"
        >

            <section className="write-me-modal__panel">

                {/* CERRAR */}
                <button
                    type="button"
                    className="write-me-modal__close"
                    onClick={() => {
                        dialogRef.current?.close();
                        closeModal();
                    }}
                >
                    ✕
                </button>

                <form
                    className="write-me-modal__form"
                    autoComplete="off"
                    onSubmit={onFormSubmit}
                >

                    <div className="write-me-modal__body">
                        {!isSent ? (
                            <>
                                <h2 className="write-me-modal__title">
                                    {t('form.pregunta')}
                                </h2>

                                {/* NOMBRE */}
                                <label className="write-me-modal__field">

                                    <span className="write-me-modal__field-label">
                                        {t('form.nombre')}
                                    </span>

                                    <input
                                        type="text"
                                        value={nombre}
                                        onChange={onInputChangeNombre}
                                        className="write-me-modal__field-control"
                                    />

                                </label>

                                {/* EMAIL */}
                                <label className="write-me-modal__field">

                                    <span className="write-me-modal__field-label">
                                        {t('form.email')}
                                    </span>

                                    <input
                                        type="email"
                                        value={correo}
                                        onChange={onInputChangeCorreo}
                                        className="write-me-modal__field-control"
                                    />

                                </label>

                                {/* SELECT */}
                                <label className="write-me-modal__field">

                                    <span className="write-me-modal__field-label">
                                        {t('form.selecciona-categoria')}
                                    </span>

                                    <select
                                        className="write-me-modal__field-control"
                                        name="subject"
                                        onChange={onInputChange}
                                        value={subject}
                                    >
                                        <option value="">
                                            {t('form.selecciona-categoria')}
                                        </option>

                                        <option value="Categoria de interes:Libertad">{(t('categorias.categoria-1'))}</option>
                                        <option value="Categoria de interes:Educación">{(t('categorias.categoria-2'))}</option>
                                        <option value="Categoria de interes:Arte & Cultura">
                                            {(t('categorias.categoria-3'))}
                                        </option>
                                        <option value="Categoria de interes:Medio Ambiente">
                                            {(t('categorias.categoria-4'))}
                                        </option>
                                        <option value="Categoria de interes:Liderazgo">{(t('categorias.categoria-5'))}</option>
                                        <option value="Categoria de interes:Innovación & Emprendiento">
                                            {(t('categorias.categoria-6'))}
                                        </option>
                                        <option value="Categoria de interes:Estado de Derecho">
                                            {(t('categorias.categoria-7'))}
                                        </option>
                                        <option value="Categoria de interes:Biblioteca">{(t('categorias.categoria-8'))}</option>
                                        <option value="Categoria de interes:Prosperidad Incluyente">
                                            {(t('categorias.categoria-9'))}
                                        </option>

                                    </select>

                                </label>

                                {/* TEXTAREA */}
                                <label className="write-me-modal__field">

                                    <span className="write-me-modal__field-label">
                                        {t('form.comparte-PH')}
                                    </span>

                                    <textarea
                                        className="write-me-modal__field-control"
                                        name="body"
                                        maxLength={560}
                                        value={body}
                                        onChange={handleInputChangeValidated}
                                    />

                                </label>

                                <p className="conteo">
                                    {count}/560 {t('form.caracteres')}
                                </p>

                                <div class="contenedor_Comentario2 ">

                                    {isLoading
                                        ? (
                                            <span>
                                                Enviando...
                                            </span>
                                        )
                                        : (
                                            <button
                                                class="btnSuscri subscribe-modal__submit typo-book-title"
                                                type="submit"
                                            >
                                                {t('form.enviar')}
                                            </button>
                                        )}

                                </div>
                            </>
                        ) : (

                            <div className="write-me-modal__success">

                                <img className='img-success-pal' src='/assets/img2026/palomita.svg' />

                                <h2 className="write-me-modal__title">
                                    {i18n.language === "en"
                                        ? "Thank you for submitting your topic proposal."
                                        : "Gracias por enviar tu propuesta de tema."}
                                </h2>



                                <button
                                    type="button"
                                    className="btnSuscri subscribe-modal__submit typo-book-title"
                                    onClick={handleClose}
                                >
                                    {i18n.language === "en"
                                        ? "Close"
                                        : "Cerrar"}
                                </button>

                            </div>
                        )}



                    </div>

                </form>

            </section>

        </dialog>
    );
};

export default IdeasForm;